import {
  isLosslessNumber,
  parse as losslessParse,
  stringify,
} from 'lossless-json';

export function prettifyJSONRaw(jsonString: string): string {
  if (jsonString === null || jsonString === '' || jsonString === undefined)
    return '';

  const obj = parse(jsonString);

  const stringifyWithNoSpacing = stringify(obj, null, 0);
  const parsedJSON = parse(stringifyWithNoSpacing);

  return stringify(parsedJSON, null, 4);
}

export function prettifyJSON(obj: { [key: string]: any }): string {
  if (obj === null || obj === undefined) return '';

  const stringifyWithNoSpacing = stringify(obj, null, 0);
  const parsedJSON = parse(stringifyWithNoSpacing);

  return stringify(parsedJSON, null, 4);
}

function tryFormatJson(
  value: string,
  fomatter: (obj: object) => string,
): string {
  let obj: object;
  try {
    obj = parse(value) as object;

    return fomatter(obj);
  } catch (e) {
    return value;
  }
}

export function tryBeautifyJson(value: string): string {
  return tryFormatJson(value, prettifyJSON);
}

export function parse(value: string): { [key: string]: any } {
  const parsedValue = losslessParse(value);

  removeLosslessObject(parsedValue);

  return parsedValue;
}

export function removeLosslessObject(obj: any): any {
  if (isLosslessNumber(obj)) {
    return obj.valueOf();
  }

  if (obj === null || obj === undefined || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i += 1) {
      obj[i] = removeLosslessObject(obj[i]);
    }
    return obj;
  }

  Object.keys(obj).forEach((key) => {
    obj[key] = removeLosslessObject(obj[key]);
  });

  return obj;
}
